<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" label="E-mail signature">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <email-my-signature />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-mail"
      label="Google Groups Sync"
      v-if="
        hasPermission(
          'vp.crm.engageconfiguration.emailsynclist.view'
        )
      "
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <email-sync-list />
      </div>
    </vs-tab>

    <vs-tab
      icon-pack="feather"
      icon="icon-facebook"
      label="Facebook Pages Sync"
      v-if="
        hasPermission(
          'vp.crm.engageconfiguration.messengersync.view'
        )
      "
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <messenger-sync-list />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import MessengerSyncList from "./Messenger/MessengerSyncList.vue";
import EmailSyncList from "./Email/EmailSyncList.vue";
import EmailMySignature from "./Email/EmailMySignature.vue";

import { mapGetters } from "vuex";

export default {
  components: { EmailSyncList, EmailMySignature, MessengerSyncList },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>